/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 * Page dashboard translation constants
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.1
 */

import IPageDashboardTranslation, {
    IWidgetsTranslation,
} from '@modules/internationalization/types/pages/dashboard/dashboard';

import initTranslationWidgetCosts from './widgetCosts';
import initWidgetMultiBalancesTranslation from './widgetMultiBalancesTranslation';
import initTranslationOrderInquiries from './widgetOrderInquiries';
import initTranslationWidgetPaymentHistory from './widgetPaymentHistory';
import initTranslationWidgetPersonalAccount from './widgetPersonalAccount';
import { initTranslationWidgetReportsConstructor } from './widgetReportsConstructor';
import initTranslationWidgetSearchAccounts from './widgetSearchAccounts';
import initTranslationWidgetSubscriberMaxCosts from './widgetSubscriberMaxCosts';
import initTranslationWidgetSubscriberMobile from './widgetSubscriberMobile';
import initTranslationWidgetUsefulLinks from './widgetUsefulLinks';
import initTranslationWidgetVoting from './widgetVoting';

export const initTranslationWidgets: IWidgetsTranslation = {
    costs: initTranslationWidgetCosts,
    multiBalances: initWidgetMultiBalancesTranslation,
    orderInquiries: initTranslationOrderInquiries,
    paymentHistory: initTranslationWidgetPaymentHistory,
    personalAccount: initTranslationWidgetPersonalAccount,
    searchAccounts: initTranslationWidgetSearchAccounts,
    subscriberMaxCosts: initTranslationWidgetSubscriberMaxCosts,
    subscriberMobile: initTranslationWidgetSubscriberMobile,
    usefulLinks: initTranslationWidgetUsefulLinks,
    voting: initTranslationWidgetVoting,
    reportsConstructor: initTranslationWidgetReportsConstructor,
};

const initTranslationPageDashboard: IPageDashboardTranslation = {
    error: {
        defaultMessage: '',
        codes: {},
    },
    widgets: initTranslationWidgets,
};

export default initTranslationPageDashboard;
